import EyeIcons from '@/icons/EyeIcons'
import { useTranslation } from 'react-i18next'
import { Popover, Typogaphy } from 'vnetwork-ui'

interface MetadataProps {
    metadata: any
}

const Metadata: React.FC<MetadataProps> = ({ metadata }) => {
    const { t } = useTranslation()
    const keyChanges = Object?.keys(metadata?.old || ({} as object))

    return (
        <Popover
            interactive
            render={(attrs) =>
                metadata ? (
                    <div
                        {...attrs}
                        className="p-4 rounded-[8px] bg-white shadow-md"
                    >
                        <div className="flex gap-4 mt-2">
                            <div>
                                {keyChanges?.map((item) => (
                                    <div
                                        key={item}
                                        className="flex gap-4 items-center py-2 border-b last:border-b-0"
                                    >
                                        <Typogaphy className="font-semibold">
                                            {t(item)}:
                                        </Typogaphy>

                                        <Typogaphy className="line-through">
                                            {typeof metadata?.old?.[item] ===
                                            'string' ? (
                                                metadata?.old?.[item]
                                            ) : (
                                                <pre>
                                                    {JSON.stringify(
                                                        metadata?.old?.[item],
                                                        null,
                                                        2
                                                    )}
                                                </pre>
                                            )}
                                        </Typogaphy>

                                        <Typogaphy>{'==>'}</Typogaphy>

                                        <Typogaphy>
                                            {typeof metadata?.new?.[item] ===
                                            'string' ? (
                                                metadata?.new?.[item]
                                            ) : (
                                                <pre>
                                                    {JSON.stringify(
                                                        metadata?.new?.[item],
                                                        null,
                                                        2
                                                    )}
                                                </pre>
                                            )}
                                        </Typogaphy>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    <></>
                )
            }
            appendTo={document.body}
        >
            <div className="cursor-pointer">
                {metadata ? (
                    <EyeIcons className="icon-small" />
                ) : (
                    <Typogaphy>---</Typogaphy>
                )}
            </div>
        </Popover>
    )
}

export default Metadata
